var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a-row",
    { attrs: { gutter: 24 } },
    [
      _c(
        "a-col",
        { attrs: { md: 24 } },
        [
          _c(
            "a-card",
            { style: _vm.cardStyle, attrs: { bordered: false } },
            [
              _c(
                "div",
                { staticClass: "table-page-search-wrapper" },
                [
                  _c(
                    "a-form",
                    {
                      attrs: { layout: "inline" },
                      nativeOn: {
                        keyup: function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          )
                            return null
                          return _vm.searchQuery.apply(null, arguments)
                        },
                      },
                    },
                    [
                      _c(
                        "a-row",
                        { attrs: { gutter: 24 } },
                        [
                          _c(
                            "a-col",
                            { attrs: { md: 6, sm: 24 } },
                            [
                              _c(
                                "a-form-item",
                                {
                                  attrs: {
                                    label: "订单状态",
                                    labelCol: _vm.labelCol,
                                    wrapperCol: _vm.wrapperCol,
                                  },
                                },
                                [
                                  _c(
                                    "a-select",
                                    {
                                      attrs: {
                                        allowClear: "",
                                        placeholder: "请选择订单状态",
                                      },
                                      model: {
                                        value: _vm.queryParam.orderStatus,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.queryParam,
                                            "orderStatus",
                                            $$v
                                          )
                                        },
                                        expression: "queryParam.orderStatus",
                                      },
                                    },
                                    _vm._l(
                                      _vm.orderStatusMap,
                                      function (name, status) {
                                        return _c(
                                          "a-select-option",
                                          {
                                            key: status,
                                            attrs: { value: status },
                                          },
                                          [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(name) +
                                                "\n                  "
                                            ),
                                          ]
                                        )
                                      }
                                    ),
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "a-col",
                            { attrs: { md: 6, sm: 24 } },
                            [
                              _c(
                                "a-form-item",
                                {
                                  attrs: {
                                    label: "来源",
                                    labelCol: _vm.labelCol,
                                    wrapperCol: _vm.wrapperCol,
                                  },
                                },
                                [
                                  _c(
                                    "a-select",
                                    {
                                      attrs: {
                                        allowClear: "",
                                        placeholder: "请选择来源",
                                      },
                                      model: {
                                        value: _vm.queryParam.sourceType,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.queryParam,
                                            "sourceType",
                                            $$v
                                          )
                                        },
                                        expression: "queryParam.sourceType",
                                      },
                                    },
                                    _vm._l(
                                      _vm.sourceTypeMap,
                                      function (name, type) {
                                        return _c(
                                          "a-select-option",
                                          { key: type, attrs: { value: type } },
                                          [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(name) +
                                                "\n                  "
                                            ),
                                          ]
                                        )
                                      }
                                    ),
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "span",
                            {
                              staticClass: "table-page-search-submitButtons",
                              staticStyle: {
                                float: "left",
                                overflow: "hidden",
                              },
                            },
                            [
                              _c(
                                "a-col",
                                { attrs: { md: 12, sm: 24 } },
                                [
                                  _c(
                                    "a-button",
                                    {
                                      attrs: { type: "primary" },
                                      on: { click: _vm.searchQuery },
                                    },
                                    [_vm._v("查询")]
                                  ),
                                  _c(
                                    "a-button",
                                    {
                                      staticStyle: { "margin-left": "8px" },
                                      on: { click: _vm.searchReset },
                                    },
                                    [_vm._v("重置")]
                                  ),
                                  _c(
                                    "a-button",
                                    {
                                      staticStyle: { "margin-left": "8px" },
                                      attrs: { icon: "sync" },
                                      on: { click: _vm.handleSyncStatus },
                                    },
                                    [_vm._v("同步状态")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "section",
                [
                  _c("a-table", {
                    ref: "table",
                    attrs: {
                      size: "middle",
                      bordered: "",
                      rowKey: "id",
                      columns: _vm.columns,
                      dataSource: _vm.dataSource,
                      pagination: false,
                      scroll: _vm.scroll,
                      loading: _vm.loading,
                    },
                    on: { change: _vm.handleTableChange },
                    scopedSlots: _vm._u([
                      {
                        key: "sourceType",
                        fn: function (text) {
                          return [
                            _c(
                              "a-tag",
                              {
                                attrs: {
                                  color: _vm.sourceTypeColor[text] || "",
                                },
                              },
                              [_vm._v(_vm._s(_vm.sourceTypeMap[text] || text))]
                            ),
                          ]
                        },
                      },
                      {
                        key: "orderStatus",
                        fn: function (text, record) {
                          return [
                            _c(
                              "a-tag",
                              {
                                attrs: {
                                  color: _vm.orderStatusColor[text] || "",
                                },
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    record.orderStatusName ||
                                      _vm.orderStatusMap[text] ||
                                      text
                                  )
                                ),
                              ]
                            ),
                          ]
                        },
                      },
                      {
                        key: "action",
                        fn: function (text, record) {
                          return [
                            record.subType === "销售订单"
                              ? [
                                  _vm.canRelate(record)
                                    ? _c(
                                        "a",
                                        {
                                          on: {
                                            click: function ($event) {
                                              return _vm.handleRelate(record)
                                            },
                                          },
                                        },
                                        [_vm._v("关联商品")]
                                      )
                                    : _vm._e(),
                                  _c(
                                    "a",
                                    {
                                      on: {
                                        click: function ($event) {
                                          return _vm.showQrCode(record)
                                        },
                                      },
                                    },
                                    [_vm._v("出库码")]
                                  ),
                                  _c("a-divider", {
                                    attrs: { type: "vertical" },
                                  }),
                                  _c(
                                    "a",
                                    {
                                      on: {
                                        click: function ($event) {
                                          return _vm.handlePrintShd(record)
                                        },
                                      },
                                    },
                                    [_vm._v("送货单")]
                                  ),
                                ]
                              : _vm._e(),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
              _c(
                "a-modal",
                {
                  attrs: {
                    title: _vm.qrTitle,
                    footer: null,
                    width: 360,
                    centered: "",
                  },
                  model: {
                    value: _vm.qrVisible,
                    callback: function ($$v) {
                      _vm.qrVisible = $$v
                    },
                    expression: "qrVisible",
                  },
                },
                [
                  _c(
                    "div",
                    { staticClass: "qr-wrapper" },
                    [
                      _vm.qrBase64
                        ? _c("img", {
                            staticClass: "qr-img",
                            attrs: {
                              src: "data:image/png;base64," + _vm.qrBase64,
                              alt: "出库二维码",
                            },
                          })
                        : _vm._e(),
                      _c("div", { staticClass: "qr-info" }, [
                        _c("p", [
                          _vm._v("出库单号：" + _vm._s(_vm.qrData.xsckBillNo)),
                        ]),
                        _c("p", [
                          _vm._v("关联订单：" + _vm._s(_vm.qrData.xsddBillNo)),
                        ]),
                        _c("p", { staticClass: "qr-tip" }, [
                          _vm._v(
                            "请客户在 H5「扫码入库」中扫描或输入此二维码内容"
                          ),
                        ]),
                      ]),
                      _c(
                        "a-button",
                        {
                          staticStyle: { "margin-top": "12px" },
                          attrs: {
                            type: "primary",
                            block: "",
                            icon: "printer",
                          },
                          on: { click: _vm.printQrCode },
                        },
                        [_vm._v("打印二维码")]
                      ),
                    ],
                    1
                  ),
                ]
              ),
              _c("order-center-print", { ref: "orderPrint" }),
              _c(
                "a-modal",
                {
                  attrs: {
                    title: _vm.relateTitle,
                    visible: _vm.relateVisible,
                    confirmLoading: _vm.relateLoading,
                    maskClosable: false,
                    width: "760px",
                  },
                  on: {
                    ok: _vm.handleRelateOk,
                    cancel: function ($event) {
                      _vm.relateVisible = false
                    },
                  },
                },
                [
                  _c("a-table", {
                    attrs: {
                      size: "small",
                      bordered: "",
                      rowKey: "itemId",
                      columns: _vm.relateColumns,
                      dataSource: _vm.relateItems,
                      pagination: false,
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "materialSelect",
                        fn: function (text, item) {
                          return [
                            _c(
                              "a-select",
                              {
                                staticStyle: { width: "280px" },
                                attrs: {
                                  showSearch: "",
                                  optionFilterProp: "children",
                                  placeholder: "请选择本方商品",
                                },
                                model: {
                                  value: item.materialId,
                                  callback: function ($$v) {
                                    _vm.$set(item, "materialId", $$v)
                                  },
                                  expression: "item.materialId",
                                },
                              },
                              _vm._l(_vm.materialOptions, function (material) {
                                return _c(
                                  "a-select-option",
                                  {
                                    key: material.id,
                                    attrs: { value: material.id },
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          material.materialName || material.name
                                        ) +
                                        "\n              "
                                    ),
                                  ]
                                )
                              }),
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("div", { staticClass: "relate-tip" }, [
                    _vm._v(
                      "关联后本方商品将替换订单中的占位商品，并自动建立商品对应关系（后续同商品订单自动匹配）"
                    ),
                  ]),
                ],
                1
              ),
              _c("a-pagination", {
                staticStyle: { "margin-top": "16px", "text-align": "right" },
                attrs: {
                  current: _vm.ipagination.current,
                  pageSize: _vm.ipagination.pageSize,
                  total: _vm.ipagination.total,
                },
                on: {
                  change: _vm.paginationChange,
                  showSizeChange: _vm.paginationShowSizeChange,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }